import { MouseEvent } from 'react';
import { getSearchResultItemURL } from '@/features/navigation/utils/url-helpers';
import { NavigationCarousel } from '@/features/carousel';
import { IconClock, IconTrash } from '@/features/icons';
import { EasyAccess } from '@/features/tag';
import MobileSearchLink from './mobile-search-link';
import useSearchHistory from './utils/use-search-history';
interface Props {
  handleClickItem: (e: MouseEvent, href: string) => void;
}
function LastSearchHistory({
  handleClickItem
}: Props) {
  const {
    searchHistoryItems,
    clearSearchHistory
  } = useSearchHistory();
  if (!searchHistoryItems) return null;
  return <div className='mb-5 lg:px-1' data-sentry-component="LastSearchHistory" data-sentry-source-file="last-search-history.tsx">
            <div className='mb-3 flex items-center justify-between leading-6'>
                <div className='flex flex-row items-center'>
                    <IconClock className='h-5 w-5' data-sentry-element="IconClock" data-sentry-source-file="last-search-history.tsx" />
                    <span className='pr-2 text-sm font-medium'>آخرین جست‌وجوهای شما</span>
                </div>
                <IconTrash className='h-5 w-5 cursor-pointer text-text-mediumGray' onClick={clearSearchHistory} data-sentry-element="IconTrash" data-sentry-source-file="last-search-history.tsx" />
            </div>

            <NavigationCarousel className='flex' options={{
      perView: 'auto',
      spacing: 4,
      mode: 'free'
    }} data-sentry-element="NavigationCarousel" data-sentry-source-file="last-search-history.tsx">
                {searchHistoryItems?.map(item => {
        const itemHref = getSearchResultItemURL(item);
        return <MobileSearchLink key={item.id} href={itemHref} item={item} onClick={e => handleClickItem(e, itemHref)} className='keen-slider__slide min-w-fit max-w-fit'>
                            <EasyAccess size='medium' className='text-nowrap border-border-gray-light bg-white' showClose={false}>
                                {item.nameFa}
                            </EasyAccess>
                        </MobileSearchLink>;
      })}
            </NavigationCarousel>
        </div>;
}
export default LastSearchHistory;